<script lang="ts">

    import Modal from './Modal.svelte';
    import TopBar from './TopBar.svelte';
    import SocialAuth from './SocialAuth.svelte';
    import { user } from '../Services';
    import { createEventDispatcher } from 'svelte';

    export let open: boolean = false;
    export let title: string = 'Iniciar sesión';

    const dispatch = createEventDispatcher();

    let showAuthModal = false;

    $: showAuthModal = open;

    function onClose() {
        showAuthModal = false;
        dispatch('close');
    }

</script>

<style lang="scss">

    .auth-modal {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .auth-modal-content {
        color: var(--color-secondary);
        padding: 1rem;
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

</style>

{#if showAuthModal}
<Modal --zIndex="600">
    <div class="auth-modal">
        <TopBar on:back={onClose} {title} />
        <div class="auth-modal-content">
        {#if !$user}
            <slot name="instructions">
                <p>Inicia sesión para continuar.</p>
            </slot>
            <SocialAuth on:auth_success />
        {:else}
            <slot name="welcome">
                Bienvenid@ <strong>{$user.name}</strong>
            </slot>
        {/if}
        </div>
    </div>
</Modal>
{/if}
